"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookiesConsentContextProvider = void 0;
/* eslint-disable react-hooks/exhaustive-deps */
const react_1 = __importStar(require("react"));
const CookiesConsentContext_1 = require("./CookiesConsentContext");
const cookieConsentPreferences_1 = require("../models/cookieConsentPreferences");
const CookieConsentModal_1 = __importDefault(require("../components/modal/CookieConsentModal"));
const CookieConsentWaterMarkButton_1 = __importDefault(require("../components/CookieConsentWaterMarkButton"));
const cookieConsentShowModalType_1 = require("../models/cookieConsentShowModalType");
const useService_1 = require("../hooks/useService");
const CookiesConsentContextProvider = (props) => {
    const { children, config, intlLang } = props;
    const [cookieConsentPreferences, setCookieConsentPreferences] = (0, react_1.useState)(cookieConsentPreferences_1.DEFAULT_COOKIE_CONSENT_PREFERENCES);
    const [cookieConsentShowModal, setCookieConsentShowModal] = (0, react_1.useState)(cookieConsentShowModalType_1.CookieConsentShowModalType.HIDE_ALL);
    const [defaultConsentIsSet, setDefaultConsentIsSet] = (0, react_1.useState)(false);
    const [activateYoutubeCookies, setActivateYoutubeCookies] = (0, react_1.useState)(false);
    const [activateKlaviyoCookies, setActivateKlaviyoCookies] = (0, react_1.useState)(false);
    const cookieService = (0, useService_1.useService)("CookieService");
    const gtmCookieConsentService = (0, useService_1.useService)("GtmCookieConsentService");
    const youtubeCookieConsentService = (0, useService_1.useService)("YoutubeCookieConsentService");
    const klaviyoCookieConsentService = (0, useService_1.useService)("KlaviyoCookieConsentService");
    (0, react_1.useEffect)(() => {
        const defaultCookie = cookieService.getCookieConsentPreferences();
        if (defaultCookie == null) {
            setCookieConsentShowModal(cookieConsentShowModalType_1.CookieConsentShowModalType.SMALL);
        }
        else {
            setCookieConsentShowModal(isAllAccepted(defaultCookie)
                ? cookieConsentShowModalType_1.CookieConsentShowModalType.HIDE_ALL
                : cookieConsentShowModalType_1.CookieConsentShowModalType.HIDE_MODAL);
            setCookieConsentPreferences(defaultCookie);
            updateYoutubeCookieConsent(defaultCookie);
            updateKlaviyoCookieConsent(defaultCookie);
        }
        addCookieConsentUpdateHandlers();
    }, []);
    const isAllAccepted = (cookieConsentPreferences) => {
        let isAllAccepted = true;
        for (const preference in cookieConsentPreferences) {
            if (!cookieConsentPreferences[preference]) {
                isAllAccepted = false;
                break;
            }
        }
        return isAllAccepted;
    };
    const addCookieConsentUpdateHandlers = () => {
        cookieService.addCookieConsentUpdateHandlers("youtubeCookies", updateYoutubeCookieConsent);
        cookieService.addCookieConsentUpdateHandlers("gtmCookieConsentService", (consent) => gtmCookieConsentService.setConsent(consent, false));
        cookieService.addCookieConsentUpdateHandlers("klaviyoCookies", updateKlaviyoCookieConsent);
    };
    const updateYoutubeCookieConsent = (consent) => {
        setActivateYoutubeCookies(youtubeCookieConsentService.isCookiesAccepted(consent));
    };
    const updateKlaviyoCookieConsent = (consent) => {
        setActivateKlaviyoCookies(klaviyoCookieConsentService.isCookiesAccepted(consent));
    };
    const cookiesConsentContext = {
        config: config,
        intlLang: intlLang,
        cookieConsentPreferences: cookieConsentPreferences,
        setCookieConsentPreferences: setCookieConsentPreferences,
        cookieConsentShowModal: cookieConsentShowModal,
        setCookieConsentShowModal: setCookieConsentShowModal,
        defaultConsentIsSet: defaultConsentIsSet,
        setDefaultConsentIsSet: setDefaultConsentIsSet,
        activateYoutubeCookies: activateYoutubeCookies,
        activateKlaviyoCookies: activateKlaviyoCookies,
    };
    return (react_1.default.createElement(CookiesConsentContext_1.CookiesConsentContext.Provider, { value: cookiesConsentContext },
        children,
        react_1.default.createElement(CookieConsentModal_1.default, null),
        react_1.default.createElement(CookieConsentWaterMarkButton_1.default, null)));
};
exports.CookiesConsentContextProvider = CookiesConsentContextProvider;
//# sourceMappingURL=CookiesConsentContextProvider.js.map